import { useContext } from 'react';
import { AppContext, EMPTY_OBJECT } from 'commons-ui';
import _noop from 'lodash/noop';

type Action = {
	id: string;
	isEnabled: () => boolean;
	name: string;
};

type ActionHandlerParams = {
	history: any;
	rowData: any;
};

export const makeActionHandler = (action: Action, params: ActionHandlerParams) => {
	const { rowData = EMPTY_OBJECT } = params;
	const { showAlert } = useContext(AppContext);

	switch (action.id) {
		case 'copyRow':
			return () => {
				showAlert('Copied');
				navigator.clipboard.writeText(JSON.stringify(rowData, null, 2));
			};

		default:
			return _noop;
	}
};

export default {
	makeActionHandler
};
